import { DataGrid, DataGridProps } from "@mui/x-data-grid";

export default function CustomDataGrid({
  columns,
  rows,
  ...props
}: DataGridProps) {
  return (
    <DataGrid
      columns={columns}
      rows={rows}
      sx={{
        maxHeight: "calc(100% - 79px)",
      }}
      disableRowSelectionOnClick
      disableColumnMenu
      onRowSelectionModelChange={(e) => console.log("Heyyyyyyyyyyyyyyy", e)}
      pageSizeOptions={[100, 500]}
      {...props}
    />
  );
}
